import { isNativeDevice } from "@/utils/platform";

function getModule() {
  if (isNativeDevice) {
    return require("./index.native");
  }
  return null;
}

export const registerForPushNotificationsAsync = getModule() as () => Promise<string>;
